import { GuidService } from 'ui-components/services/guid-service';

import * as OrderActions from '../../../store/orders/orders.actions';
import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';

import * as Actions from './edit.order.actions';

const initialState = {
  activeTab: 'delivery address',
  pasteAddressMode: 'closed',
  loading: false,
  showNewValidatedAddress: false,
  validatedAddress: {},
  fieldsWithError: [],
  isExpanded: false,
  hasMadeChanges: false,
};

// TODO: Fix dates :/

const setLoading = (loading) => {
  return (state) => {
    return {
      ...state,
      loading,
      itemsHaveError: false,
    };
  };
};

const actionHandlerMap = {
  [Actions.NEW_ORDER_MODAL_OPEN]: (state, { salesOrder }) => {
    return {
      ...state,
      order: {
        ...salesOrder,
        createGuid: GuidService.newGuid(),
      },
      showNewValidatedAddress: false,
      validatedAddress: {},
      hasMadeChanges: false,
    };
  },
  [Actions.NEW_ORDER_MODAL_CLOSED]: () => initialState,
  [Actions.NEW_ORDER_MODAL_HAS_MADE_CHANGES]: (state) => {
    return {
      ...state,
      hasMadeChanges: true,
    };
  },
  [OrderActions.CREATE_ORDER_REQUEST]: setLoading(true),
  [OrderActions.UPDATE_ORDER_SUCCESS]: setLoading(false),
  [OrderActions.CREATE_ORDER_SUCCESS]: setLoading(false),
  [OrderActions.CREATE_ORDER_FAILURE]: setLoading(false),
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './edit.order.reducer.metadata';
